import styled from "styled-components";


export const Title = styled.h2`
    font-style: normal;
    font-weight: 900;
    font-size: 26px;
    line-height: 32px;
    color: #000000;
`



export const Summary = styled.p`
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 32px;
`
export const Content = styled.div`
min-width:50vw;
`